import {ICompanySettings} from '@core/api/data-access';

export type ICompanySettingsState = {
	settings: ICompanySettings;
	loading: boolean;
	loaded: boolean;
};

export const companySettingsInitialState: ICompanySettingsState = {
	settings: null,
	loading: false,
	loaded: false,
};
